import { CommonModule, DatePipe } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DatasearchService } from '../../_services/datasearch.service';
import {
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  filter,
  Subject,
} from 'rxjs';
import { search_filter } from '../../../_model/search_fliter';
import { AuthenticationService } from '../../_services/authentication.service';
import { ConstantService } from '../../_services/constant.service';
import { GlobalService } from '../../_services/global.service';
import { BusyService } from '../../_services/busy.service';
import { user_privilege } from '../../../_model/user_privilege';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogModule } from 'primeng/dialog';
import { CommanService } from '../../_services/comman.service';
import { tap, switchMap } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-dynamic-search',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    DialogModule,
  ],
  templateUrl: './dynamic-search.component.html',
  styleUrl: './dynamic-search.component.scss',
  providers: [MessageService],
})
export class DynamicSearchComponent implements AfterViewInit {
  dynamicformvalue: any = {};
  isTableDynamic: boolean = false;
  // @Output() receivedynamicsearchdata = new EventEmitter<{
  //   response: string;
  //   userid: string;
  //   gbrn: string;
  //   INCHIKEY: string;
  //   currentFilterCondition: any;
  //   application_query: string;
  //   search_filters: search_filter;
  //   cols: any;
  //   columns: any;
  //   totalRecords: any;
  //   searchQueryGrid: string;
  // }>();

  // @Output() emitUserPrivilege = new EventEmitter<{
  //   privilege_json: any;
  //   userid: string;
  //   keyword?: string;
  // }>();

  TableName: string = 'basic_product_details_MONGO';
  pageTitile = 'QuikPatent';
  isSignedIn = false;
  tokenChecked = false;
  searchTypeOptions = [
    { type: 'Exact', label: 'Exact Search' },
    {
      type: 'Free',
      label: 'Free text search (Broad Search, it may take more time)',
    },
  ];
  searchOptions: any[] = [
    { name: 'Simple Search', value: 'SIMPLE' },
    { name: 'Advance Search', value: 'ADVANCE' },
    { name: 'Dynamic Search', value: 'Dynamic' },
    // { name: "Claim / Example Search", value: "CLAIM" }
  ];
  gbrn: any;
  user_data: any;
  current_pagenumber: number = 1;
  filterForm_dynamic: FormGroup = new FormGroup({});
  selectedSearchOption = 0;
  searchForm!: FormGroup;
  items: any[] = [];
  selectedOption: string = '';
  formValues: any[] = [];
  results_suggestion: any[] = [];
  dynamicFields: any = {}; // To store the distinct values for each field
  selectedFilters: any = {};
  isShowQueryBox: boolean = false;
  isShowAutoSearch: boolean = false;
  isShowTable: boolean = false;
  isQueryErrorFound: boolean = false;
  noResultsFound: boolean = false;
  searchQueryGrid: string = '';
  searchType = 'Exact';
  patentTypes: any[] = [];
  addOnPatentTypes: any[] = [];
  filterForm_advanced: FormGroup = new FormGroup({});
  isShowAccessDialog: boolean = false;
  IsFilterAplied: boolean = false;
  analysisApi: boolean = false;
  isQueryOptionSelected: boolean = false;
  IsSuggestedItemClick: boolean = false;
  columns: any[] = [];
  isShowReadMoreDialog: boolean = false;
  initializedForm: boolean = false;
  isListView: boolean = true;
  isShowRaiseQuery: boolean = false;
  is_show_Total_Search_Exceed_popup: boolean = false;
  is_show_Search_Priv_popup: boolean = false;
  is_show_Daily_Search_Exceed_popup: boolean = false;
  is_show_Download_Priv_popup: boolean = false;
  is_show_Daily_Download_Exceed_popup: boolean = false;
  is_show_Total_Download_Exceed_popup: boolean = false;
  productDetails: boolean = false;
  analysisView: boolean = false;
  isValidQueryCondition: boolean = true;
  currentFilterCondition: any = [];
  currentSortBy: string = '';
  application_query: string = '';
  search_filters!: search_filter;
  user_ip: string = '';
  address: string = '';
  additionalOperator: string = '';
  products_current_datasource: any[] = [];
  analysisFilterVal: any = [];
  rptDataForExcel: any = [];
  textsearch = '';
  searchedWords: string[] = [];
  searchFields = ['', 'combination'];
  SuggestedDbColumn: string = '';
  SuggestedDbField: string = '';
  dynSelectedPatentType: string = '';
  lastSearchQuery: string = '';
  readMoreColumn: string = '';
  readMoreContent: string = '';
  dateValue: any = {};
  tablefilter: any = {};
  analysisData: any = {};
  detailViewData: any = {};
  totalRecords: any;
  isLoadAutoSearch: boolean = false;
  updatePrivilege = false;
  loading_table = false;
  first = 0;
  oldResult: any = {};
  oldSearchQueryGrid = '';
  listSortByfield: string = '';
  listSortOrder: string = 'ASC';
  colCntAutoSearch: number = 0;
  privilege_json!: user_privilege;
  public searchTerms = new Subject<string>();
  postdata: any = {
    mode: 'GET_AUTO_SUGGEST',
  };
  results: string[] = [];
  searchCondition: any = {};
  isDataExistsAutoSearch: boolean = true;
  filteredProducts: any[] = [];
  dropdownSuggestions: any = [];
  operatorSelected: string = '';
  fieldSelected: string = '';
  matchText: string = '';
  searchValueFromEmail: string | null = null;
  rows: number = 15;
  cols: any[] = [];
  tableData: any = null;
  isDataApiDone: boolean = false;
  isCountApiDone: boolean = false;
  loadingCompleted: boolean = false;
  displayVideoModal: boolean = false;
  videoUrl: any;
  pageLimitInPrivilegeJson: any = 0;
  pageLimitInDatabaseLimit: any = 0;
  regex_query =
    /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\((?<value>.*?)\)/gm;
  // search_regex_query = /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\((?<value>(?:[^(]+|\([^)]*\))*)\)/g;
  search_regex_query =
    /\s*(?<operator>AND|OR|NOT)?\s*(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\s*\((?<value>[^()]*?(?:\s+TO\s+[^()]*?)?)\)\s*/g;
  regex_query1 =
    /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\((?<value>.*?)\)/gm;
  regex_query2 = /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+)/gi;

  querySuggestions: any = [
    { search_value: 'AND', columnName: 'AND', label: 'Operator' },
    { search_value: 'OR', columnName: 'OR', label: 'Operator' },
    { search_value: 'NOT', columnName: 'NOT', label: 'Operator' },
    {
      search_value: 'EQUAL TO',
      columnName: 'EQUAL TO',
      label: 'Date Operator',
    },
    {
      search_value: 'NOT EQUAL TO',
      columnName: 'NOT EQUAL TO',
      label: 'Date Operator',
    },
    { search_value: 'BETWEEN', columnName: 'BETWEEN', label: 'Date Operator' },
    {
      search_value: 'NOT BETWEEN',
      columnName: 'NOT BETWEEN',
      label: 'Date Operator',
    },
    { search_value: '(term)', columnName: '(term)', label: 'Field Text' },
    {
      search_value: '(term1 AND term2)',
      columnName: '(term1 AND term2)',
      label: 'Field Text',
    },
    {
      search_value: '(term1 OR term2)',
      columnName: '(term1 OR term2)',
      label: 'Field Text',
    },
    {
      search_value: '(dd-mm-yyyy TO *)',
      columnName: '(dd-mm-yyyy TO *)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO * AND dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO * AND dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO * OR dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO * OR dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO dd-mm-yyyy AND dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO dd-mm-yyyy AND dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO dd-mm-yyyy OR dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO dd-mm-yyyy OR dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
  ];
  receivedData: any = null;
  constructor(
    private datasearch: DatasearchService,
    private authentication: AuthenticationService,
    private _constant: ConstantService,
    private globalService: GlobalService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private busyService: BusyService,
    private changeDetectorRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private commanService: CommanService,
    private router: Router,
    private messageService: MessageService
  ) {
    this.setIpandLocation();
    this.filterForm_dynamic = this.fb.group({
      textautocomplete: new FormControl(''),
    });
    this.$searchKeyword
      .pipe(
        // If character length is greater than 2
        filter((res: any) => res.length > 2),
        // Time in milliseconds between key events
        debounceTime(1000),
        // If the previous query is different from the current
        distinctUntilChanged()
      )
      .subscribe((text: string) => {
        let searchvalue = text;

        // Define the search condition
        this.searchCondition = {};

        if (searchvalue != '') {
          // let columnname =
          //   this.filterForm_normal.controls['textautocomplete'].value.tableColumnName;
          let columnname = this.filterForm_dynamic.value.search_type_simple;

          // Split the search term into words, considering special characters as delimiters
          let searchWordArr = searchvalue.split(/[^\w\s]/gi);

          // Check if the column exists and add search condition
          if (!this.searchCondition.hasOwnProperty(columnname)) {
            this.searchCondition[columnname] = [];
          }

          // Add the regex for each word in the search term
          searchWordArr.forEach((text) => {
            this.searchCondition[columnname].push({
              [columnname]: { $regex: text, $options: 'i' },
            });
          });

          // Prepare the request object for fetching data
          this.postdata = {
            tablename: 'basic_product_details_MONGO',
            columnname: columnname,
            searchCondition: this.searchCondition,
            pagenumber: 1,
            rowscount: 15, // Adjusted to fetch more results
          };

          // Call the API with the prepared search condition
          this.datasearch.quik_patent_dropdown(this.postdata).subscribe(
            (res) => {
              let datasearch: any = [];
              let len =
                this.filterForm_dynamic.controls[
                  'textautocomplete'
                ].value.trim().length;
              this.isShowAutoSearch = len > 2 ? true : false;
              if (len > 2) {
                let searchvalue =
                  this.filterForm_dynamic.controls[
                    'textautocomplete'
                  ].value.trim();
                this.searchTerms.next(searchvalue);
              } else {
                this.searchTerms.next('');
              }
              // Process the search results
              res.forEach((searchValue: any) => {
                let valArr = searchValue.search_value.split(/[;+]/);
                valArr.forEach((val: any) => {
                  // Check if the value matches the search term
                  if (
                    val
                      .toLowerCase()
                      .includes(
                        this.filterForm_dynamic.controls[
                          'textautocomplete'
                        ].value.toLowerCase()
                      )
                  ) {
                    datasearch.push({
                      search_value: val,
                      columnname: searchValue.columnname,
                      label: searchValue.label,
                    });
                  }
                });
              });

              // Remove duplicate search values
              const unique = datasearch.filter((obj: any, index: any) => {
                return (
                  index ===
                  datasearch.findIndex(
                    (o: any) =>
                      obj.search_value === o.search_value &&
                      obj.columnname === o.columnname
                  )
                );
              });
              datasearch = unique;

              // Update the suggestion list
              this.results_suggestion = datasearch;
              this.colCntAutoSearch =
                this.results_suggestion.length > 0 ? 1 : 0;

              this.isDataExistsAutoSearch = this.results_suggestion.length > 0;
              this.isLoadAutoSearch = false;
            },
            (error) => {
              // Handle errors (if any)
            }
          );
        }
      });
  }

  ngOnInit() {
    this.privilege_json = this.authentication.getUserPrivilege();
    if (this.privilege_json) {
      this.commanService.setUserPrivilege(this.privilege_json);
    }
    this.authentication.getCurrentUserValue().subscribe((val: any) => {
      this.user_data = val;
      this.isSignedIn = val;
      if (this.isSignedIn) {
        this.loadSearchCols();
        // this.getUserPrivilege();
        // this.loadTableConfig();
        // this.loadColumnDetails();
        // this.loadPatents();
        // this.route.queryParams.subscribe((params) => {
        //   const findParam = params['find'];
        //   if (findParam) {
        //     // console.log("find preset")
        //     this.searchValueFromEmail = decodeURIComponent(findParam).replace(
        //       /%20/g,
        //       ' '
        //     );
        //     if (this.searchValueFromEmail) {
        //       this.isShowTable = true;
        //       this.searchQueryGrid = this.searchValueFromEmail;
        //       this.filterForm_dynamic
        //         .get('textautocomplete')
        //         ?.setValue('Chlorantraniliprole');
        //       this.searchQuery();
        //       setTimeout(() => {
        //         this.searchQuery();
        //       }, 1000);
        //     }
        //   }
        // });
      }
    });

    // Get isTable value
    this.commanService.isTableDynamic.subscribe((res) => {
      this.isTableDynamic = res;
    });
    // This method get page limit data for XIM 1.0
    this.datasearch
      .GetDatabasePageLimit({
        database: 'AgroPat Ultimate Discovery Suite Beta',
      })
      .subscribe(
        (res: any) => {
          if (res.status) {
            this.pageLimitInDatabaseLimit = res.data.page_limit
              ? Number(res.data.page_limit)
              : 0;
          } else {
            console.log('Error success false');
          }
        },
        (error: any) => {
          console.log('Error :', error);
        }
      );
    // Get current page number and row
    combineLatest([
      this.commanService.currentPage,
      this.commanService.currentRow,
    ]).subscribe(([page, row]) => {
      if (this.current_pagenumber !== page || this.rows !== row) {
        this.current_pagenumber = page;
        this.rows = row;

        this.handlePageLimit();
        if (this.pageLimitInPrivilegeJson) {
          if (this.current_pagenumber > +this.pageLimitInPrivilegeJson) {
            this.commanService.userPageLimit.next(
              this.pageLimitInPrivilegeJson
            );
            this.commanService.showPageLimitWarning.next(true);
            setTimeout(() => {
              this.commanService.showPageLimitWarning.next(false);
            }, 1000);
            // this.messageService.add({
            //   severity: 'warn',
            //   summary: 'Page Limit Exceeded',
            //   detail: `You can only see ${this.pageLimitInPrivilegeJson} pages.`,
            //   life: 5000, // Duration in milliseconds
            // });
            // alert(
            //   'You can only see ' + this.pageLimitInPrivilegeJson + ' pages'
            // );
            return;
          }
        } else if (this.pageLimitInDatabaseLimit) {
          if (this.current_pagenumber > +this.pageLimitInDatabaseLimit) {
            this.commanService.userPageLimit.next(
              this.pageLimitInDatabaseLimit
            );
            this.commanService.showPageLimitWarning.next(true);
            setTimeout(() => {
              this.commanService.showPageLimitWarning.next(false);
            }, 1000);
            // this.messageService.add({
            //   severity: 'warn',
            //   summary: 'Page Limit Exceeded',
            //   detail: `You can only see ${this.pageLimitInPrivilegeJson} pages.`,
            //   life: 5000, // Duration in milliseconds
            // });
            // alert(
            //   'You can only see ' + this.pageLimitInDatabaseLimit + ' pages'
            // );
            return;
          }
        }

        if (this.isTableDynamic) {
          this.search();
        }
      }
    });
    // Get current page number and row
    //  combineLatest([
    //    this.commanService.currentPage,
    //    this.commanService.currentRow,
    //  ]).subscribe(([page, row]) => {
    //    if (this.current_pagenumber !== page || this.rows !== row) {
    //      this.current_pagenumber = page;
    //      this.rows = row;
    //      if(this.isTableDynamic){
    //        this.search();
    //      }
    //    }
    //  });

    this.globalService.sendMenuIndex(0);
    this.initializeForm();
    this.get_dynamic_feilds();
    this.updatedynamicsearch();
    // this.getdropdown();
    this.commanService.resetFlag.subscribe((reset) => {
      if (reset) {
        this.resetForm();

        this.commanService.resetFlag.next(false); // Reset flag back to false after handling
      }
    });
  }

  /////////////// Search by email ////////////////
  searchByEmail() {
    this.route.queryParams.subscribe((params) => {
      const encodedData = params['emailsearch'];
      if (encodedData) {
        this.receivedData = JSON.parse(decodeURIComponent(encodedData));
        if (this.receivedData && this.receivedData.searchType === 'Dynamic') {
          this.updateFormDynamicForm(this.receivedData.searchValue);
          setTimeout(() => {
            this.search();
          }, 2000);
        }
      }
    });
  }

  updateFormDynamicForm(data: any) {
    Object.keys(data).forEach((key) => {
      if (this.filterForm_dynamic.controls[key]) {
        this.filterForm_dynamic.controls[key].setValue(data[key]);
      }
    });
  }
  resetForm() {
    this.commanService.dynamicformvalue.next({});
    this.filterForm_dynamic.reset(); // Resets all fields to their default state
  }
  resetallform() {
    this.commanService.resetFlag.next(true);
  }
  openSignInForm() {
    this.globalService.sendOpenSignInModal(true);
  }
  openSignUpForm() {
    this.globalService.sendOpenSignUpModal(true);
  }
  initializeForm() {
    //Normal Form
    this.filterForm_dynamic = this.fb.group({
      launchingStatus: new FormControl(''),
      yearWiseOffPatentMolecule: new FormControl(''),
      launchingYear: new FormControl(''),
      startDate: new FormControl(''),
      endDate: new FormControl(''),
      yearOfDiscovery: new FormControl(''),
      propertyGeneric: new FormControl(''),
      isoPublication: new FormControl(''),
      innovator: new FormControl(''),
      InnovatorCountry: new FormControl(''),
    });
  }
  searchQuery() {
    // this.oldResult = {
    //   products_current_datasource: this.products_current_datasource,
    //   totalRecords: this.totalRecords,
    //   searchQueryGrid: this.oldSearchQueryGrid
    // }
    // this.showAnalysisView(true);
    this.analysisView = false;
    this.isQueryOptionSelected = true;
    // this.isQueryOptionSelected=false;
    this.isQueryErrorFound = false;
    //replace more than one space
    this.searchQueryGrid = this.searchQueryGrid.replace(/\s{2,}/gm, '');
    this.lastSearchQuery = JSON.stringify(this.searchQueryGrid);
    // this.searchData();
  }
  // search() {
  //   this.updatePrivilege = true;
  //   this.results_suggestion = [];
  //   this.isShowAutoSearch = false;

  //   if (this.checkUserSearchPrivillege() == false) {
  //     return;
  //   }

  //   // Push data into formValues array
  //   const formValue = {
  //     selectedOption: this.selectedOption,
  //     inputText: this.filterForm_dynamic.value,
  //   };

  //   let formData = this.filterForm_dynamic.value;
  //   if(formData.launchingStatus == ""
  //     && formData.yearWiseOffPatentMolecule == ""
  //     && formData.launchingYear == ""
  //     && formData.startDate == ""
  //     && formData.endDate == ""
  //     && formData.yearOfDiscovery == ""
  //     && formData.propertyGeneric == ""
  //     && formData.isoPublication == ""
  //     && formData.innovator == ""
  //   ){
  //     return;
  //   }

  //   this.formValues.push(formValue);
  //   this.isShowTable = false;
  //   this.isQueryErrorFound = false;
  //   this.searchQueryGrid = '';

  //   // Generate postdata for the query
  //   let postdata = this.generateQuery(this.filterForm_dynamic.value);

  //   // Start the API call to get the count of records first
  //   this.busyService.busy();
  //   this.datasearch.discovery_suite_data_count(postdata).pipe(
  //     tap((res: any) => {
  //       let response = res;
  //       if (response?.status === 'error') {
  //         this.busyService.idle();
  //         return;
  //       }

  //       // Process count response and set the flag for no results found
  //       this.totalRecords = response[0]?.TotalRecordsCount || 0;
  //       this.loadingCompleted = true;

  //       if (this.totalRecords === 0) {
  //         this.noResultsFound = true;
  //       } else {
  //         this.noResultsFound = false;
  //       }

  //       window.scrollTo(0, 0);
  //     }),
  //     switchMap(() => {
  //       // After count response, make the actual data request
  //       return this.datasearch.get_suite_data(postdata);
  //     })
  //   ).subscribe(
  //     (res) => {
  //       this.busyService.idle();
  //       let response: any = res[0];

  //       if (response?.status == 'error') {
  //         return;
  //       }

  //       // Emit the dynamic search data
  //       const gbrnArray = response.map((item: any) => item.gbrn);
  //       const inchiKeyArray = response.map((item: any) => item.INCHIKEY);

  //       this.commanService.currentData.next({
  //         INCHIKEY: response[0]?.INCHIKEY,
  //         gbrn: response[0]?.gbrn,
  //         data: response,
  //         userid: this.user_data.userid,
  //         currentFilterCondition: this.currentFilterCondition,
  //         updatePrivilege: this.updatePrivilege,
  //         application_query: this.application_query,
  //         search_filters: this.search_filters,
  //         cols: res[1] || [],
  //         columns: this.columns,
  //         totalRecords: this.totalRecords,
  //         searchQueryGrid: this.searchQueryGrid,
  //         gbrnArray: gbrnArray,
  //         inchiKeyArray: inchiKeyArray,
  //       });

  //       this.commanService.isTableDynamic.next(true);
  //       this.commanService.dynamicformvalue.next(this.filterForm_dynamic.value);
  //       this.router.navigate(['/search']);

  //       this.loading_table = false;
  //     },
  //     (errorobj) => {
  //       this.busyService.idle();
  //     },
  //     () => {
  //       this.busyService.idle();
  //       this.loading_table = false;
  //     }
  //   );
  // }

  handlePageLimit() {
    this.pageLimitInPrivilegeJson =
      this.privilege_json.PageLimit || 0 ? this.privilege_json.PageLimit : 0;
  }

  search() {
    this.isDataApiDone = false;
    this.isCountApiDone = false;
    this.updatePrivilege = true;
    this.results_suggestion = [];
    this.isShowAutoSearch = false;

    if (this.checkUserSearchPrivillege() == false) {
      return;
    }

    // Push data into formValues array
    const formValue = {
      selectedOption: this.selectedOption,
      inputText: this.filterForm_dynamic.value,
    };

    let formData = this.filterForm_dynamic.value;
    if (
      !formData.launchingStatus &&
      !formData.yearWiseOffPatentMolecule &&
      !formData.launchingYear &&
      !formData.startDate &&
      !formData.endDate &&
      !formData.yearOfDiscovery &&
      !formData.propertyGeneric &&
      !formData.isoPublication &&
      !formData.innovator &&
      !formData.InnovatorCountry
    ) {
      return;
    }

    this.formValues.push(formValue);
    this.isShowTable = false;
    this.isQueryErrorFound = false;
    this.searchQueryGrid = '';

    // Call search data method
    let postdata = this.generateQuery(this.filterForm_dynamic.value);
    this.busyService.busy();
    try {
      this.datasearch.get_suite_data(postdata).subscribe(
        (res) => {
          this.busyService.idle();
          let response: any = res.data.results;
          this.tableData = res.data.results;
          this.totalRecords = res.data.totalCount || 0;
          if (response?.status == 'error') {
            return;
          }
          // Emit search data
          //   this.receivedynamicsearchdata.emit({
          //     INCHIKEY: response[0]?.INCHIKEY,
          //     gbrn: response[0]?.gbrn,
          //     response: response,
          //     userid: this.user_data.userid,
          //     currentFilterCondition: this.currentFilterCondition,
          //     application_query: this.application_query,
          //     search_filters: this.search_filters,
          //     cols: res[1] || [], // Fallback to an empty array if undefined
          //     columns: this.columns,
          //     totalRecords: this.totalRecords, // Include totalRecords here
          //     searchQueryGrid: this.searchQueryGrid,
          // });
          this.isDataApiDone = true;
          this.isCountApiDone = true; 
          this.dataForTable(this.tableData, this.totalRecords);
          // const gbrnArray = response.map((item: any) => item.gbrn);
          // const inchiKeyArray = response.map((item: any) => item.INCHIKEY);
          // this.commanService.currentData.next({
          //   INCHIKEY: response[0]?.INCHIKEY,
          //   gbrn: response[0]?.gbrn,
          //   data: response,
          //   userid: this.user_data.userid,
          //   currentFilterCondition: this.currentFilterCondition,
          //   updatePrivilege: this.updatePrivilege,
          //   application_query: this.application_query,
          //   search_filters: this.search_filters,
          //   cols: res[1] || [],
          //   columns: this.columns,
          //   totalRecords: this.totalRecords,
          //   searchQueryGrid: this.searchQueryGrid,
          //   gbrnArray: gbrnArray,
          //   inchiKeyArray: inchiKeyArray,
          // });
          this.commanService.isTableDynamic.next(true);
          this.commanService.dynamicformvalue.next(
            this.filterForm_dynamic.value
          );
          this.router.navigate(['/search']);

          this.loading_table = false;
        },
        (errorobj) => {
          this.busyService.idle();
        },
        () => {
          this.busyService.idle();
          this.loading_table = false;
        }
      );
    } catch (error) {
      this.busyService.idle();
    }

    // Get the count of total records
    // this.busyService.busy();
    // this.datasearch.discovery_suite_data_count(postdata).subscribe(
    //   (res) => {
    //     let response: any = res;

    //     if (response?.status == 'error') {
    //       this.busyService.idle();
    //       return;
    //     }
    //     this.busyService.idle();
    //     this.totalRecords = response[0]?.TotalRecordsCount || 0;
    //     this.loadingCompleted = true;
    //     this.isCountApiDone = true;
    //     this.dataForTable(this.tableData, this.totalRecords);
    //     // Check if no records are found
    //     // if (this.totalRecords === 0) {
    //     //   console.log('No results found'); // Log for debugging
    //     //   this.noResultsFound = true; // Set the flag to true
    //     // } else {
    //     //   this.noResultsFound = false; // Set the flag to false
    //     // }
    //     // window.scrollTo(0, 0);
    //   },
    //   (errorobj) => {
    //     this.busyService.idle();
    //   }
    // );
  }

  generateQuery(formData: any): any {
    let criteriaConditions: any[] = [];
    let applicationQueryParts: string[] = [];
    let sortBy: string = formData.sortBy || 'ISOMERISM DESC';

    this.search_filters = new search_filter();
    this.search_filters.SeachType = 'Dynamic Filter';
    this.search_filters.textColumn = [];
    this.search_filters.textValue = [];

    const isAnyFieldSelected = Object.keys(formData).some(
      (key) => formData[key] && key !== 'sortBy'
    );
    if (!isAnyFieldSelected) return null;

    const addToSearchFilters = (field: string, value: string) => {
      this.search_filters.textColumn.push(field);
      this.search_filters.textValue.push(value);
      applicationQueryParts.push(`${field}:(${value})`);
    };

    const addCriteria = (
      field: string,
      keyword: any,
      operator: string = 'AND'
    ) => {
      criteriaConditions.push({ field, keyword, operator });
    };

    // ============= NUMERIC FIELDS FIX =============
    if (formData.yearOfDiscovery) {
      const year = Number(formData.yearOfDiscovery);
      if (!isNaN(year)) {
        addCriteria(
          'yearOfDiscovery',
          year.toString(),
          criteriaConditions.length === 0 ? '' : 'AND'
        );
        addToSearchFilters('yearOfDiscovery', year.toString());
      }
    }

    if (formData.launchingYear) {
      const year = Number(formData.launchingYear);
      if (!isNaN(year)) {
        addCriteria(
          'launchingYear',
          year,
          criteriaConditions.length === 0 ? '' : 'AND'
        );
        addToSearchFilters('launchingYear', year.toString());
      }
    }

    if (formData.yearWiseOffPatentMolecule) {
      const year = Number(formData.yearWiseOffPatentMolecule);
      if (!isNaN(year)) {
        addCriteria(
          'yearWiseOffPatentMolecules',
          year,
          criteriaConditions.length === 0 ? '' : 'AND'
        );
        addToSearchFilters('yearWiseOffPatentMolecules', year.toString());
      }
    }
    // ===============================================

    if (formData.launchingStatus) {
      addCriteria(
        'launchStatus',
        formData.launchingStatus,
        criteriaConditions.length === 0 ? '' : 'AND'
      );
      addToSearchFilters('launchStatus', formData.launchingStatus);
    }

    if (formData.propertyGeneric) {
      addCriteria(
        'genericPropDevCadateWdrw',
        formData.propertyGeneric,
        criteriaConditions.length === 0 ? '' : 'AND'
      );
      addToSearchFilters('genericPropDevCadateWdrw', formData.propertyGeneric);
    }

    if (formData.InnovatorCountry) {
      addCriteria(
        'dummy1',
        formData.InnovatorCountry,
        criteriaConditions.length === 0 ? '' : 'AND'
      );
      addToSearchFilters('dummy1', formData.InnovatorCountry);
    }

    if (formData.isoPublication) {
      const isoPublication =
        formData.isoPublication.value || formData.isoPublication;
      if (typeof isoPublication === 'string') {
        const yearMatch = isoPublication.match(/^(\d{4})$/);
        const monthYearMatch = isoPublication.match(/([a-zA-Z]+)\s(\d{4})/);

        if (yearMatch) {
          const year = yearMatch[1];
          addCriteria(
            'isoPublication',
            year,
            criteriaConditions.length === 0 ? '' : 'AND'
          );
          addToSearchFilters('isoPublicationYear', year);
        } else if (monthYearMatch) {
          const month = monthYearMatch[1];
          const year = monthYearMatch[2];
          addCriteria(
            'isoPublication',
            `${month} ${year}`,
            criteriaConditions.length === 0 ? '' : 'AND'
          );
          addToSearchFilters('isoPublicationMonthYear', `${month} ${year}`);
        }
      }
    }

    if (formData.innovator) {
      addCriteria(
        'notes',
        formData.innovator,
        criteriaConditions.length === 0 ? '' : 'AND'
      );
      addToSearchFilters('innovator', formData.innovator);
    }

    // ===== Date Range =====
    let dateRangeFilter: any = null;
    if (formData.startDate || formData.endDate) {
      const hasStart = formData.startDate && !isNaN(new Date(formData.startDate).getTime());
      const hasEnd = formData.endDate && !isNaN(new Date(formData.endDate).getTime());

      if (hasStart || hasEnd) {
        let dateConditions: any[] = [];
        if (hasStart) {
          dateConditions.push({
            $gte: [{ $toDate: '$genericConstrainingDate' }, { $toDate: formData.startDate }]
          });
        }
        if (hasEnd) {
          dateConditions.push({
            $lte: [{ $toDate: '$genericConstrainingDate' }, { $toDate: formData.endDate }]
          });
        }

        dateRangeFilter = {
          $expr: {
            $and: dateConditions
          }
        };

        addToSearchFilters(
          'DATE_RANGE',
          `${formData.startDate || '...'} to ${formData.endDate || '...'}`
        );
      }
    }

    // Check if we have ANY reason to search
    if (criteriaConditions.length === 0 && !dateRangeFilter) return null;

    this.application_query = applicationQueryParts.join(' | ');
    this.searchQueryGrid = this.application_query;

    const postdata = {
      search_type: this.searchOptions[this.selectedSearchOption]?.value || 'exact',
      criteria: criteriaConditions,
      pagenumber: this.current_pagenumber || 1,
      rowscount: this.rows || 10,
      sortby: sortBy,
      filters: dateRangeFilter ? [dateRangeFilter] : [],
      activityObj: {
        userId: this.user_data?.userid || 'guest',
        userEmail:this.user_data?.email || '',
        privilegeName: this.updatePrivilege || 'discovery_suite_search',
        mode: 'search',
        query: this.application_query || 'N/A',
        searchFilters: this.search_filters || 'N/A',
        userIp: this.user_ip || '',
        address: this.address || '',
      },
    };

    return postdata;
  }

  showVideoModal() {
    // URL of the video you want to display
    const videoLink =
      'https://www.chemrobotics.com/agropat/uploads/web_videos/ChemRobotics-AgroPat-Tutorial-Agrochemical-Pesticide.mp4';
    // Sanitize the URL and store it in videoUrl
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(videoLink);

    this.displayVideoModal = true; // Open the modal
  }

  dateConditionArr(colValArr: any, columnname: any, operator: any, i: any) {
    let andArr: any = [];
    let orArr: any = [];
    let searchCondition: any = [];
    if (operator === 'NOT') {
      if (colValArr[1]) {
        searchCondition.push({ $and: [] });
        searchCondition[0]['$and'].push({
          $expr: {
            $lte: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[0], 'yyyy-MM-dd') },
            ],
          },
        });
        searchCondition[0]['$and'].push({
          $expr: {
            $gte: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[1], 'yyyy-MM-dd') },
            ],
          },
        });
      } else {
        searchCondition.push({
          $expr: {
            $ne: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[0], 'yyyy-MM-dd') },
            ],
          },
        });
      }
    } else {
      if (colValArr[1]) {
        searchCondition.push({ $and: [] });
        searchCondition[0]['$and'].push({
          $expr: {
            $gte: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[0], 'yyyy-MM-dd') },
            ],
          },
        });
        searchCondition[0]['$and'].push({
          $expr: {
            $lte: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[1], 'yyyy-MM-dd') },
            ],
          },
        });
      } else {
        searchCondition.push({
          $expr: {
            $eq: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[0], 'yyyy-MM-dd') },
            ],
          },
        });
      }
    }

    if (i === 0 || operator === 'OR') {
      orArr.push({ $or: searchCondition });
    } else {
      andArr.push({ $or: searchCondition });
    }
    // });
    if (orArr.length > 0) {
      andArr.push({ $or: orArr });
    }
    return andArr;
  }

  get_dynamic_feilds() {
    this.datasearch.get_dynamic_feilds().subscribe(
      (res) => {
        if (!res || !res.data) return;

        const data = res.data;

        // --- Helper: Clean numeric arrays ---
        const cleanNumberArray = (arr: any[]) =>
          arr
            .filter((v) => v !== null && v !== '' && !isNaN(Number(v)))
            .map((v) => Number(v));

        // --- Helper: Clean normal arrays ---
        const cleanStringArray = (arr: any[]) =>
          arr.filter((v) => v !== null && v !== '');

        // ====== NUMERIC FIELDS CLEANING ======
        this.dynamicFields.launchingYear = cleanNumberArray(
          data.launchingYear || []
        );

        this.dynamicFields.yearWiseOffPatentMolecules = cleanNumberArray(
          data.yearWiseOffPatentMolecules || []
        );

        this.dynamicFields.yearOfDiscovery = cleanNumberArray(
          data.yearOfDiscovery || []
        );

        // ====== COUNTRY / DUMMY FIELDS ======
        const excludedIcons = [
          'Cosmetic_Chemistry.png',
          'Pharma_Medicine.png',
          'Synthetic_Dyes.png',
          'protein.png',
        ];

        this.dynamicFields.dummy1 = (data.dummy1 || []).filter(
          (item: any) => !excludedIcons.includes(item)
        );

        // ====== COMMENTRY (YEAR OR MONTH-YEAR OPTIONS) ======
         if (data.isoPublication) {
          this.dynamicFields.isoPublication = data.isoPublication.flatMap((row: any) => {
            const year = row.value;

            const yearOption = {
              label: `${year}`,
              value: `${year}`,
            };

            const monthOptions = row.months.map((m: any) => ({
              label: `${m} ${year}`,
              value: `${m} ${year}`,
            }));

            return [yearOption, ...monthOptions];
          });
        } else {
          this.dynamicFields.isoPublication = [];
        }

        // ====== OTHER FIELDS SAFETY CLEAN ======
        Object.keys(data).forEach((key) => {
          if (!this.dynamicFields[key] && key !== 'isoPublication') {
            const val = Array.isArray(data[key])
              ? cleanStringArray(data[key])
              : data[key];

            this.dynamicFields[key] = val;
          }
        });

        console.log('✅ Cleaned dynamicFields:', this.dynamicFields);
      },

      (error) => {
        console.error('❌ Error fetching dynamic fields:', error);
      }
    );
  }

  onDropdownChange(field: string, event: any) {
    let value = event.value;

    // strict numeric fields
    const numericFields = [
      'launchingYear',
      'yearOfDiscovery',
      'yearWiseOffPatentMolecule',
    ];

    if (numericFields.includes(field)) {
      // convert to number
      const num = Number(value);

      if (isNaN(num)) {
        console.warn('❌ Invalid numeric value, resetting:', value);
        value = null; // prevent sending "i"
      } else {
        value = num; // safe numeric
      }
    }

    // update
    this.selectedFilters[field] = value;
    this.filterForm_dynamic.patchValue({ [field]: value });
  }

  truncateName(name: string, maxWords: number): string {
    // Ensure the input is a string before calling split
    if (typeof name !== 'string') {
      return name; // Return the original value if it's not a string
    }

    const words = name.split(' ');
    if (words.length > maxWords) {
      return words.slice(0, maxWords).join(' ') + '...'; // Optionally, add ellipsis if truncated
    }
    return name;
  }

  checkUserSearchPrivillege(): boolean {
    this.IsFilterAplied = false;

    //Check User Have Access to Search
    if (!this.privilege_json.View) {
      this.is_show_Search_Priv_popup = true;
      this.messageService.add({
        severity: 'error',
        summary: 'Access Denied',
        detail: 'You do not have privilege to view this database.',
      });
      return false;
    }
    //Check Daily Search Exceed
    const todaySearchCount =
      Number(this.privilege_json.today_search_count) || 0;
    const dailySearchLimit = Number(this.privilege_json.DailySearchLimit) || 0;
    if (todaySearchCount >= dailySearchLimit) {
      this.is_show_Daily_Search_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your daily search limit.',
      });
      return false;
    }
    //Check Total Search Exceed
    const searchCount = Number(this.privilege_json.Search) || 0;
    if (searchCount <= 0) {
      this.is_show_Total_Search_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your total available search limit.',
      });
      return false;
    }

    this.IsFilterAplied = true;
    this.privilege_json.Search = searchCount - 1;
    this.privilege_json.today_search_count = todaySearchCount + 1;

    // Save updated counts to localStorage
    const userid = this.user_data?.userid || 'guest';
    const dailyKey = `user_${userid}_daily_counts`;

    const today = new Date().toDateString();
    localStorage.setItem(
      dailyKey,
      JSON.stringify({
        date: today,
        today_search_count: this.privilege_json.today_search_count,
        today_download_count: this.privilege_json.today_download_count || 0,
      })
    );
    return true;
  }

  ngAfterViewInit(): void {
    document.addEventListener('click', this.onOutsideClick.bind(this));
    this.searchByEmail();
  }
  onOutsideClick(event: MouseEvent): void {
    const suggestionBox = document.querySelector(
      '.search_top_body_container_simple_mid_right_suggestion'
    );
    const targetElement = event.target as HTMLElement;

    // Check if the click is outside the suggestion box
    if (suggestionBox && !suggestionBox.contains(targetElement)) {
      this.isShowAutoSearch = false; // Hide suggestions
    }
  }
  private existingValues: { [key: string]: boolean } = {};
  checkUserDownloadPrivillege(): boolean {
    console.log('Checking download privileges');
    //Check User Have Access to Search
    if (!this.privilege_json.Download) {
      console.log('User does not have download access');
      this.is_show_Download_Priv_popup = true;
      this.messageService.add({
        severity: 'error',
        summary: 'Access Denied',
        detail: 'You do not have privilege to download data from this database.',
      });
      return false;
    }
    //Check Daily Search Exceed
    const todayDownloadCount =
      Number(this.privilege_json.today_download_count) || 0;
    const dailyDownloadLimit =
      Number(this.privilege_json.DailyDownloadLimit) || 0;
    console.log(
      `Checking daily download limit: today=${todayDownloadCount}, limit=${dailyDownloadLimit}`
    );
    if (todayDownloadCount >= dailyDownloadLimit) {
      console.log('Daily download limit exceeded');
      this.is_show_Daily_Download_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your daily download limit.',
      });
      return false;
    }
    //Check Total Search Exceed
    const downloadCount = Number(this.privilege_json.DownloadCount) || 0;
    console.log(`Checking total download count: remaining=${downloadCount}`);
    if (downloadCount <= 0) {
      console.log('Total download count exceeded');
      this.is_show_Total_Download_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your total available download limit.',
      });
      return false;
    }
    this.privilege_json.DownloadCount = downloadCount - 1;
    this.privilege_json.today_download_count = todayDownloadCount + 1;

    // Save updated counts to localStorage
    const today = new Date().toDateString();
    const userData = {
      date: today,
      today_search_count: this.privilege_json.today_search_count,
      today_download_count: this.privilege_json.today_download_count,
    };
    localStorage.setItem(
      `user_${this.user_data.userid}_daily_counts`,
      JSON.stringify(userData)
    );

    console.log(
      `Updated download counts: total=${this.privilege_json.DownloadCount}, today=${this.privilege_json.today_download_count}`
    );

    return true;
  }
  loadSearchCols() {
    let postdata = {
      tablename: 'templateBasicProductDetailsMongos',
    };
    this.datasearch.GetTemplateCols(postdata).subscribe((res) => {
      this.columns = res.data;
      this.columns.sort((a: any, b: any) => {
        return a.DisplayColumnName.localeCompare(b.DisplayColumnName);
      });
      this.columns.forEach((col) => {
        if (!this.existingValues[col.tableColumnName]) {
          this.querySuggestions.push({
            search_value: col.tableColumnName,
            columnName: col.DisplayColumnName,
            label: 'Field',
            fieldDataType: col.fieldDataType,
          });
          this.existingValues[col.tableColumnName] = true;
        }
      });
      if (!this.existingValues['patentType']) {
        this.querySuggestions.push({
          search_value: 'patentType',
          columnName: 'PATENT TYPE',
          label: 'Field',
        });
        this.existingValues['patentType'] = true;
      }
    });
  }

  // async getUserPrivilege(): Promise<void> {
  //   this.authentication.getCurrentUserSubject().subscribe((val) => {
  //     this.user_data = val;

  //     this.authentication
  //       .getUserPrivilege({
  //         mode: 'GET_USER_PRIVILEGE',
  //         userid: val.userid,
  //         app_json_name: 'agroultimate',
  //         application_name: 'agroultimate Platform',
  //       })
  //       .subscribe({
  //         next: async (res: any) => {
  //           // Process privilege_json
  //           this.privilege_json = this._constant.getAppprivilege(
  //             res.privilege_json,
  //             'agroultimate',
  //             val.userid
  //           );

  //           // Emit the data using a new EventEmitter
  //           // this.emitUserPrivilege.emit({
  //           //   privilege_json: this.privilege_json,
  //           //   userid: val.userid,
  //           //   keyword: this.route.snapshot.params['keyword'] || '',
  //           // });

  //           // Handle keyword logic
  //           if (this.route.snapshot.params['keyword']) {
  //             this.staticSuggestion(
  //               'keyword',
  //               '',
  //               this.route.snapshot.params['keyword']
  //             );
  //           }
  //         },
  //         error: (err) => {
  //           console.error('Error fetching privilege JSON:', err);
  //         },
  //       });
  //   });
  // }

  staticSuggestion(columnname: any, title: any, search_value: any) {
    switch (columnname) {
      case 'keyword':
        this.IsSuggestedItemClick = false;
        this.SuggestedDbColumn = '';
        this.filterForm_dynamic.controls['textautocomplete'].setValue(
          search_value
        );
        this.search();
        break;
      default:
        let searchItem = {
          columnname: columnname,
          field: title,
          search_value: search_value,
        };
        this.autoSearchSelect(searchItem);
        break;
    }
  }
  autoSearchSelect(Item: any) {
    this.isShowAutoSearch = false;
    this.results_suggestion = [];
    this.filterForm_dynamic
      .get('textautocomplete')
      ?.setValue(Item.search_value);

    this.search();
  }
  $searchKeyword: Subject<string> = new Subject<string>();
  searchKeyword(event: any) {
    this.$searchKeyword.next(event.target.value);
  }
  setIpandLocation() {
    this.datasearch.getIpandLocation().subscribe({
      next: (res) => {
        this.user_ip = res.userip;
        this.address = res.address;
        console.log('🌐 User Info:', res);
      },
      error: (err) => {
        console.error('❌ Error fetching IP/Location:', err);
      },
    });
  }
  updatedynamicsearch() {
    this.commanService.dynamicformvalue.subscribe((res) => {
      this.dynamicformvalue = res;

      this.filterForm_dynamic.patchValue({
        launchingStatus: this.dynamicformvalue.launchingStatus,
        yearWiseOffPatentMolecule:
          this.dynamicformvalue.yearWiseOffPatentMolecule,
        launchingYear: this.dynamicformvalue.launchingYear,
        startDate: this.dynamicformvalue.startDate,
        endDate: this.dynamicformvalue.endDate,
        yearOfDiscovery: this.dynamicformvalue.yearOfDiscovery,
        propertyGeneric: this.dynamicformvalue.propertyGeneric,
        isoPublication: this.dynamicformvalue.isoPublication,
        innovator: this.dynamicformvalue.innovator,
      });
    });
  }
  dataForTable(data: any, count: any) {
    if (this.isDataApiDone && this.isCountApiDone) {
      const gbrnArray = data.map((item: any) => item.gbrn);
      const inchiKeyArray = data.map((item: any) => item.inchiKey);
      const activeIngredientArray = data.map(
        (item: any) => item.activeIngredient
      );

      this.commanService.currentData.next({
        inchiKey: data[0]?.inchiKey,
        gbrn: data[0]?.gbrn,
        activeIngredient: data[0]?.activeIngredient,
        data: data,
        userid: this.user_data.userid,
        currentFilterCondition: this.currentFilterCondition,
        application_query: this.application_query,
        search_filters: this.search_filters,
        cols: data[1] || [],
        columns: this.columns,
        totalRecords: count,
        searchQueryGrid: this.searchQueryGrid,
        gbrnArray: gbrnArray,
        inchiKeyArray: inchiKeyArray,
        activeIngredientArray: activeIngredientArray,
      });

      this.isDataApiDone = false;
      this.isCountApiDone = false;
      this.tableData = null;

      if (this.totalRecords === 0) {
        this.noResultsFound = true;
      } else {
        this.noResultsFound = false;
      }
    } else {
      return;
    }
  }
}
